module.exports = function($scope, file, $timeout, $docUpload){
  $scope.file = file && file.blobId ? file : null;
  $scope.form = {}
  $scope.form.failedFiles = [];
  $scope.validationFilter = 'image';
  $scope.allowedFiles = $docUpload.GetAllowedUploadTypes($scope.validationFilter);

  $scope.upload = function(){
    $timeout($scope.uploadInternal)
  }

  $scope.remove = function($event){
    $event.preventDefault();
    $scope.closeThisDialog({action: 'removed'});
  }

  $scope.uploadInternal = function(){

    var onErrorCallback = function(failedFile) {
      $scope.form.busy = false;
      $scope.form.failedFiles.push(failedFile);
    }

    var onPendingCallback = function(f) {
      $scope.closeThisDialog({action: 'uploaded', file: {
        blobId: f.id,
        fileName: f.name,
        fileSize: f.size
      }});
    }

    var onSuccessCallback = function() {
      $scope.form.busy = false;
      $scope.form.failedFiles = [];
    }

    // files property may be single file or array with single file;
    // first, check property for null
    var fileOrFiles = $scope.form.files;
    if (!fileOrFiles) return;

    // deal with array/object difference
    var file;
    if (Array.isArray(fileOrFiles)) {
      // check array has an element - bail if not
      if (fileOrFiles.length === 0) return;
      file = fileOrFiles[0];
    } else {
      // just grab the file object
      file = fileOrFiles;
    }

    $scope.form.busy = true;
    $docUpload.HandleUploadAction([file],
                                   $scope.validationFilter,
                                   onErrorCallback,
                                   onPendingCallback,
                                   onSuccessCallback);
  }


}
